var exports = {
  "k": "xf85f6308--e04cd0--container",
  "i": "xf85f6308--e04cd0--wrapper",
};

module.exports = exports;
